import { ArrowForward } from '@mui/icons-material'
import { Box } from '@mui/material'
import { accentColor } from '@/services/workspaces/workspacePresets'
import { workspaceVisual } from '@/services/workspaces/workspaceVisual'
import styles from './CreateWorkspace.module.scss'

export default function WorkspacePickerList({ workspaces, onSelect }) {
  return (
    <div className={styles.workspaceList}>
      {workspaces.map((workspace) => {
        const visual = workspaceVisual(workspace)
        return (
          <button key={workspace.id} type="button" className={styles.workspaceOption} onClick={() => onSelect(workspace.id)}>
            <Box component="span" className={styles.workspaceIcon} sx={{ backgroundColor: accentColor(workspace.accent) }}>
              {visual.kind === 'emoji' ? visual.value : <visual.Icon aria-hidden />}
            </Box>
            <span className={styles.workspaceText}>
              <span className={styles.workspaceName}>{workspace.name}</span>
              {workspace.description ? <span className={styles.workspaceDescription}>{workspace.description}</span> : null}
            </span>
            <ArrowForward fontSize="small" aria-hidden />
          </button>
        )
      })}
    </div>
  )
}
